import React from 'react';
import Box from 'fe-components/Box';
import Text from 'fe-design-base/atoms/Text';
import FdbNumberField from 'fe-design-base/molecules/NumberField';
import SelectField from 'fe-design-base/molecules/SelectField';
import TextField from 'fe-design-base/molecules/TextField';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';

import ChipGroupField from '../../../../ChipGroup/ChipGroupField';

const { cx } = cxHelpers('TaxFormField');

const CurrencyField = props => (
  <FdbNumberField leftAlign prefix="$" {...props} />
);
const NumberField = props => <FdbNumberField leftAlign {...props} places={0} />;
const FormSelectField = ({ options, ...props }) => {
  if (options.length > 2) {
    return <SelectField options={options} {...props} />;
  }

  return <ChipGroupField options={options} {...props} />;
};

const TYPES = {
  number: NumberField,
  select: FormSelectField,
  currency: CurrencyField,
  text: TextField,
};
const TaxFormField = ({
  name,
  label,
  description,
  type,
  options,
  required,
  dependsOn,
}) => {
  const { values } = useFormikContext();

  const FieldComponent = TYPES[type] || TextField;

  if (
    !dependsOn ||
    (dependsOn &&
      String(values[dependsOn.name]).match(new RegExp(dependsOn.value_matches)))
  ) {
    return (
      <Box mb={32} className={cx({ [type]: true })}>
        <FieldComponent
          name={name}
          label={label}
          options={options}
          hasAsterisk={required}
          size="medium"
        />
        <Text color="mono700" variant="captions">
          {description}
        </Text>
      </Box>
    );
  }
  return null;
};

TaxFormField.propTypes = {
  chipOptions: PropTypes.array,
  selectedValue: PropTypes.string,
  onClick: PropTypes.func,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.string.isRequired,
};

export default TaxFormField;
